import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.ConfirmationDropdown', {
    defaultTitle: 'Are you sure?',
    defaultConfirmText: 'Yes',
    defaultCancelText: 'No',
});
